import React from 'react';
import styled from 'styled-components';

import Fieldset from '@rover/components/src/formFields/Fieldset';

import ButtonGroupButton from './ButtonGroupButton';

const Wrapper = styled(Fieldset)`
  display: flex;
  flex-direction: row;
`;

export type Option = {
  key: string | number;
  label: string;
  value: string | boolean;
  'data-qa-id'?: string;
  [key: string]: any;
};

export type ButtonGroupVariant = 'default' | 'edit' | 'rounded';

export type Props = {
  buttonType?: 'radio' | 'checkbox';
  legendId?: string;
  onToggle: (option: Option, index: number, event: Event) => void;
  options: Option[];
  value?: any;
  name?: string;
  bigLabel?: boolean;
  gap?: string;
  variant?: ButtonGroupVariant;
};

const ButtonGroup = ({
  buttonType = 'checkbox',
  legendId,
  name = '',
  onToggle,
  options,
  value,
  bigLabel,
  gap,
  variant = 'default',
  ...other
}: Props): JSX.Element => {
  let buttonBorderRadius;
  if (variant === 'edit') {
    buttonBorderRadius = '8px';
  } else if (variant === 'rounded') {
    buttonBorderRadius = '50%';
  } else if (gap) {
    buttonBorderRadius = '4px';
  }

  return (
    <Wrapper
      style={{ gap, justifyContent: variant === 'rounded' ? 'space-between' : undefined }}
      legendId={legendId}
      role={buttonType === 'radio' ? 'radiogroup' : 'group'}
      {...other}
    >
      {options.map((o, i) => {
        if (buttonType === 'checkbox') {
          return (
            <ButtonGroupButton
              checked={!!o.value}
              buttonType={buttonType}
              data-qa-id={o['data-qa-id']}
              key={o.key || o.label}
              label={variant === 'rounded' ? o.label.charAt(0) : o.label}
              aria-label={o['aria-label']}
              name={name}
              onToggle={(event) => onToggle(o, i, event)}
              value={o.value}
              bigLabel={bigLabel}
              borderRadius={buttonBorderRadius}
              variant={variant}
              disabled={o.disabled}
            />
          );
        }

        return (
          <ButtonGroupButton
            buttonType={buttonType}
            checked={o.value === value}
            key={o.key || o.label}
            label={o.label}
            aria-label={o['aria-label']}
            name={name}
            onToggle={(event) => onToggle(o, i, event)}
            value={o.value}
            borderRadius={buttonBorderRadius}
            variant={variant}
            disabled={o.disabled}
          />
        );
      })}
    </Wrapper>
  );
};

export default ButtonGroup;
